import { Input } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useMissingCompanyDetailsForm } from '../../../../../../contexts/missingCompanyDetailsFormContext'

export const CompanyCity = (): ReactElement => {
  const { t } = useTranslation()
  const {
    missingCompanyDetailsForm: { FormItem },
  } = useMissingCompanyDetailsForm()

  return (
    <FormItem
      itemColumnEnd={15}
      itemColumnStart={4}
      label={t('external_invoices.missing_company_compliance_details.modal.form.field.address.city.label')}
      name="companyCity"
      render={({ field }) => {
        return <Input {...field} size="sm" />
      }}
    />
  )
}
